<template>
    <modal name="create_booking_comments" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="form.id ? $t('Edit comment') : $t('Add comment')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <app-datepicker id="date"
                                    v-model="form.date"
                                    inputType="date"
                                    name="date"
                                    rules="required">
                        <template #label>
                            {{ $t('Date') }}*
                        </template>
                    </app-datepicker>
                    <app-textarea id="comments" v-model="form.comments" name="comments" rules="required" :rows="3">
                        <template #label>
                            {{ $t('Comments') }}*
                        </template>
                    </app-textarea>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ form.id ? $t('Update') : $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import BookingService from '@services/booking.service';
import moment from 'moment';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {
                id: null,
                date: null,
                vehicle_id: null,
                comments: null,
            },
            loading: false
        };
    },
    computed: {
        ...mapGetters(['localeDateFormat'])
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    BookingService.storeBookingComments(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setBookingComments', res);
                        this.hide();
                    });
                }
            });
        },
        beforeOpen(event) {
            const vehicle = event.params.vehicle;
            const booking = event.params.booking;
            if (vehicle && !booking) {
                this.form.vehicle_id = vehicle.id;
                this.form.comment = null;
                this.form.date = moment().format(this.localeDateFormat);
            }
            if (booking && !vehicle) {
                this.form = {
                    date: moment(booking.start_time).format(this.localeDateFormat),
                    id: booking.id,
                    vehicle_id: booking.vehicle_id,
                    comments: booking.comments,
                };
            }
        },
        hide() {
            this.form = {
                date: null,
                vehicle_id: null,
                comments: null,
            };
            this.$modal.hide('create_booking_comments');
        }
    }
};
</script>
